import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AllchannelsComponent } from './pages/allchannels/allchannels.component';
import { AllCategoriesComponent } from './pages/all-categories/all-categories.component';
import { SubscriptionsComponent } from './pages/subscriptions/subscriptions.component';
import { WatchhistoryComponent } from './pages/watchhistory/watchhistory.component';
import { AccountComponent } from './user/account/account.component';
import { EditAccountComponent } from './user/edit-account/edit-account.component';
import { LoginComponent } from './user/login/login.component';
import { VideoComponent } from './pages/video/video.component';
import { RegisterComponent } from './user/register/register.component';
import { SingleChannelComponent } from './pages/singlechannel/singlechannel.component';
import { SinglecategoryComponent } from './pages/single-category/single-category.component';
import { SubscribeComponent } from './user/subscribe/subscribe.component';
import {CanActivate } from '@angular/router';
import {AuthGuardService} from './auth-guard.service';
import { PlaylistComponent } from './pages/playlist/playlist.component';
import { LivestreamComponent } from './pages/livestream/livestream.component';
import { ForgotPasswordComponent } from './user/forgot-password/forgot-password.component';
import { SearchComponent } from './pages/search/search.component';
import { LogoutComponent } from './user/logout/logout.component';
import { SubscribeOtpComponent } from './user/subscribe-otp/subscribe-otp.component';
import { MyListComponent } from './pages/my-list/my-list.component';
import { WatchLaterComponent } from './pages/watch-later/watch-later.component';
import { UnsubscribeComponent } from './user/unsubscribe/unsubscribe.component';
import { NewPasswordComponent } from './user/new-password/new-password.component';
import { SubAndRegComponent } from './user/sub-and-reg/sub-and-reg.component';
import { WrapMeComponent } from './wrap-me/wrap-me.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { DemoComponent } from './pages/demo/demo.component';
import { WinnersComponent } from './pages/winners/winners.component';
import { WoohooLandingComponent } from './pages/woohoo-landing/woohoo-landing.component';
import { SubscribeChoiceComponent } from './user/subscribe-choice/subscribe-choice.component';
import { VideoPlayerComponent } from './testing/video-player/video-player.component';
const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    component: HomeComponent,
    data: {
      title: 'Home'
  }
  },
  {
    path: 'play/:uuid',
    canActivate: [AuthGuardService],
    component: VideoPlayerComponent,
    data: {
      title: 'Play'
  }
  },
  {
    path: 'win-now',
    component: WoohooLandingComponent
  },
  {
    path: 'winners',
    component: WinnersComponent
  },
  
  {
    path: 'subscribe-options',
    component: SubscribeChoiceComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'channels',
    component: AllchannelsComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Channels'
  }
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
    data: {
      title: 'Terms and Conditions'
  }
  },
  {
    path: 'terms-and-conditions/:productID',
    component: TermsAndConditionsComponent,
    data: {
      title: 'Terms and Conditions'
  }
  },
  {
    path: 'terms-and-conditions/:productID/:isMondia/:siteID/:operatorID',
    component: TermsAndConditionsComponent,
    data: {
      title: 'Mondia Terms and Conditions'
  }
  },
  {
    path: 'categories',
    component: AllCategoriesComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'my-subscriptions',
    component: SubscriptionsComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'my-list',
    component: MyListComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'My List'
  }
  },
  {
    path: 'watch-later',
    component: WatchLaterComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'watch-history',
    component: WatchhistoryComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Account'
  }
  },
  {
    path: 'edit-account',
    component: EditAccountComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login'
  }
  },

  {
    path: 'demo',
    component: DemoComponent,
    data: {
      title: 'Demo'
  }
  },
  {
    path: 'login?status=:status&customerId=:custID&operator=:operator',
    component: LoginComponent,
    data: {
      title: 'Login'
  }
  },
  {
    path: 'login?status=:status&errorCode=:errorCode&errorDesc=:errDesc',
    component: LoginComponent,
    data: {
      title: 'Login'
  }
  },
  {
    path: 'subscribe-and-register',
    component: SubAndRegComponent,
    data: {
      title: 'Subscribe & Register'
  }
  },
  {
    path: 'en/subscribe-and-register',
    component: SubAndRegComponent
  },
  {
    path: 'ar/subscribe-and-register',
    component: SubAndRegComponent
  },
  {
    path: 'set-password',
    component: NewPasswordComponent,
    data: {
      title: 'Set Password'
  }
  },
  {
    path: 'set-password/:username',
    component: NewPasswordComponent
  },
  {
    path: 'login/:redirect',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: {
      title: 'Forgot Password'
  }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register'
  }
  },
  {
    path: 'channel/:channelID/:tab',
    component: SingleChannelComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Channel'
  }
  },
  {
    path: 'channel/:channelID/search/:searchstring',
    component: SingleChannelComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Channel Search'
  }
  },
  {
    path: 'subscribe/:channelID',
    component: SubscribeComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Subscribe'
  }
  },
  {
    path: 'subscribe/:billingAgent/:id/:billingFrequency/:currency/:cost',
    component: SubscribeComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Subscribe'
  }
  },
  {
    path: 'ar/subscribe/:channelID',
    component: SubscribeComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'ar/subscribe/:billingAgent/:id/:cost/:billingFrequency',
    component: SubscribeComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'fr/subscribe/:channelID',
    component: SubscribeComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'unsubscribe/:channelID',
    component: UnsubscribeComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Unsubscribe'
  }
  },
  {
    path: 'subscribe-confirm/:otpID/:needsReset',
    component: SubscribeOtpComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Confirm Subscription'
  }
  },
  {
    path: 'subscribe-confirm/:otpID',
    component: SubscribeOtpComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Confirm Subscription'
  }
  },
  {
    path: 'category/:tagID',
    component: SinglecategoryComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'video/:uuid',
    component: VideoComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'video/:uuid/:rf',
    component: VideoComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'playlist/:channelID/:playlistID/:tab',
    component: PlaylistComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Playlist'
  }
  },
  {
    path: 'playlist/:playlistID/search/:searchstring',
    component: PlaylistComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Playlist'
  }
  },
  {
    path: 'search/:searchString',
    component:  SearchComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'livestream',
    component: LivestreamComponent
  },
  {
    path: 'wrap-me/:wrapMeToken',
    component: WrapMeComponent,
    data: {
      title: 'Wrap Me'
  }
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  { path: '**', redirectTo: 'login',
 },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
